import React, { useCallback, useEffect } from 'react';

import BarcodeReadRegularIcon from '../../../../shared/icons/barcode-read-regular-icon';
import Button from '../../../button/button';

import { useModal } from '../../../../shared/hooks/hooks';

// import { trackAction } from '../../../../shared/utils/analytics/analytics';
import { loadScript, removeScript } from '../../../../shared/utils/page/page';

import { TIRE_SCANNER } from '../../../../shared/constants/modals';

import './scan-tire-button.scss';

const SCANNER_ID = 'tire-scanner';

interface ScanTireButtonProps {
  className?: string;
  onClick?: () => void;
  onTireScanned?: (tireWidth, selectedTireCrossDimension, tireDiameter) => void;
}

function ScanTireButton(props: ScanTireButtonProps) {
  const { className = '', onClick, onTireScanned } = props;

  const { closeModal, openModal } = useModal();

  const handleTireScanned = useCallback(
    result => {
      const defaultValue = { text: '0' };
      const {
        diameter = defaultValue,
        ratio = defaultValue,
        width = defaultValue
      } = result || {};

      onTireScanned?.(width.text, ratio.text, diameter.text);
      closeModal();
    },
    [closeModal, onTireScanned]
  );

  useEffect(() => () => removeScript(SCANNER_ID), []);

  if (!process.env.__ANYLINE_OCR_KEY__) {
    return null;
  }

  return (
    <Button
      className={`scan-tire-button ${className}`}
      isSecondary
      onClick={() => {
        onClick?.();
        if (window.anylinejs?.init) {
          openModal(TIRE_SCANNER, {
            analyticsPrefix:
              process.env.__FF_TIRE_SCAN_OCR_REDESIGN__ === 'true'
                ? 'multistep'
                : undefined,
            onTireScanned: handleTireScanned
          });
        } else {
          loadScript({
            id: SCANNER_ID,
            onload: () => {
              openModal(TIRE_SCANNER, {
                analyticsPrefix:
                  process.env.__FF_TIRE_SCAN_OCR_REDESIGN__ === 'true'
                    ? 'multistep'
                    : undefined,
                onTireScanned: handleTireScanned
              });
            },
            src: 'https://js.anyline.com/release/42.5.0/anyline.js'
          });
        }
      }}
      styleName="button"
    >
      <BarcodeReadRegularIcon styleName="icon" />
      Scan Tire Sidewall
    </Button>
  );
}

export default ScanTireButton;
